"use client";

import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { usePopoverDisclosure } from "../__chunks/QE62MSCL.js";
import "../__chunks/35RDKJF6.js";
import "../__chunks/RM6VCCZ7.js";
import "../__chunks/NWYOIOBE.js";
import "../__chunks/JOBHIYEN.js";
import { SelectArrow } from "../__chunks/R7IT6RIP.js";
import "../__chunks/A7OBCLOL.js";
import { useCompositeTypeahead } from "../__chunks/CWIRMIEN.js";
import { SelectScopedContextProvider, useSelectProviderContext } from "../__chunks/SLHXTMPQ.js";
import "../__chunks/ZHUQ44XA.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import "../__chunks/Z4WWVOIF.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import { useBooleanEvent, useEvent, useMergeRefs, useWrapElement } from "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/select/select.tsx
import { toArray } from "@ariakit/core/utils/array";
import { getPopupRole } from "@ariakit/core/utils/dom";
import { queueBeforeEvent } from "@ariakit/core/utils/events";
import { invariant } from "@ariakit/core/utils/misc";
import { useEffect, useMemo, useRef, useState } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var TagName = "button";
function getSelectedValues(select) {
  return Array.from(select.selectedOptions).map(function (option) {
    return option.value;
  });
}
function nextWithValue(store, next) {
  return function () {
    var nextId = next();
    if (!nextId) return;
    var i = 0;
    var nextItem = store.item(nextId);
    var firstItem = nextItem;
    while (nextItem && nextItem.value == null) {
      var nextId2 = next(++i);
      if (!nextId2) return;
      nextItem = store.item(nextId2);
      if (nextItem === firstItem) break;
    }
    return nextItem == null ? void 0 : nextItem.id;
  };
}
var useSelect = createHook(function useSelect2(_a) {
  var _b = _a,
    store = _b.store,
    name = _b.name,
    form = _b.form,
    required = _b.required,
    _b$showOnKeyDown = _b.showOnKeyDown,
    showOnKeyDown = _b$showOnKeyDown === void 0 ? true : _b$showOnKeyDown,
    _b$moveOnKeyDown = _b.moveOnKeyDown,
    moveOnKeyDown = _b$moveOnKeyDown === void 0 ? true : _b$moveOnKeyDown,
    _b$toggleOnPress = _b.toggleOnPress,
    toggleOnPress = _b$toggleOnPress === void 0 ? true : _b$toggleOnPress,
    _b$toggleOnClick = _b.toggleOnClick,
    toggleOnClick = _b$toggleOnClick === void 0 ? toggleOnPress : _b$toggleOnClick,
    props = __objRest(_b, ["store", "name", "form", "required", "showOnKeyDown", "moveOnKeyDown", "toggleOnPress", "toggleOnClick"]);
  var context = useSelectProviderContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "Select must receive a `store` prop or be wrapped in a SelectProvider component.");
  var onKeyDownProp = props.onKeyDown;
  var showOnKeyDownProp = useBooleanEvent(showOnKeyDown);
  var moveOnKeyDownProp = useBooleanEvent(moveOnKeyDown);
  var placement = store.useState("placement");
  var dir = placement.split("-")[0];
  var value = store.useState("value");
  var multiSelectable = Array.isArray(value);
  var onKeyDown = useEvent(function (event) {
    var _a2;
    onKeyDownProp == null ? void 0 : onKeyDownProp(event);
    if (event.defaultPrevented) return;
    if (!store) return;
    var _store$getState = store.getState(),
      orientation = _store$getState.orientation,
      items2 = _store$getState.items,
      activeId = _store$getState.activeId;
    var isVertical = orientation !== "horizontal";
    var isHorizontal = orientation !== "vertical";
    var isGrid = !!((_a2 = items2.find(function (item) {
      return !item.disabled && item.value != null;
    })) == null ? void 0 : _a2.rowId);
    var moveKeyMap = {
      ArrowUp: (isGrid || isVertical) && nextWithValue(store, store.up),
      ArrowRight: (isGrid || isHorizontal) && nextWithValue(store, store.next),
      ArrowDown: (isGrid || isVertical) && nextWithValue(store, store.down),
      ArrowLeft: (isGrid || isHorizontal) && nextWithValue(store, store.previous)
    };
    var getId = moveKeyMap[event.key];
    if (getId && moveOnKeyDownProp(event)) {
      event.preventDefault();
      store.move(getId());
    }
    var isTopOrBottom = dir === "top" || dir === "bottom";
    var isLeft = dir === "left";
    var isRight = dir === "right";
    var canShowKeyMap = {
      ArrowDown: isTopOrBottom,
      ArrowUp: isTopOrBottom,
      ArrowLeft: isLeft,
      ArrowRight: isRight
    };
    var canShow = canShowKeyMap[event.key];
    if (canShow && showOnKeyDownProp(event)) {
      event.preventDefault();
      store.move(activeId);
      queueBeforeEvent(event.currentTarget, "keyup", store.show);
    }
  });
  props = useWrapElement(props, function (element) {
    return /* @__PURE__ */jsx(SelectScopedContextProvider, {
      value: store,
      children: element
    });
  }, [store]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    autofill = _useState2[0],
    setAutofill = _useState2[1];
  var nativeSelectChangedRef = useRef(false);
  useEffect(function () {
    var nativeSelectChanged = nativeSelectChangedRef.current;
    nativeSelectChangedRef.current = false;
    if (nativeSelectChanged) return;
    setAutofill(false);
  }, [value]);
  var labelId = store.useState(function (state) {
    var _a2;
    return (_a2 = state.labelElement) == null ? void 0 : _a2.id;
  });
  var label = props["aria-label"];
  var labelledBy = props["aria-labelledby"] || labelId;
  var items = store.useState(function (state) {
    if (!name) return;
    return state.items;
  });
  var values = useMemo(function () {
    return _toConsumableArray(new Set(items == null ? void 0 : items.map(function (i) {
      return i.value;
    }).filter(function (v) {
      return v != null;
    })));
  }, [items]);
  props = useWrapElement(props, function (element) {
    if (!name) return element;
    return /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsxs("select", {
        style: {
          border: 0,
          clip: "rect(0 0 0 0)",
          height: "1px",
          margin: "-1px",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          whiteSpace: "nowrap",
          width: "1px"
        },
        tabIndex: -1,
        "aria-hidden": true,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        name: name,
        form: form,
        required: required,
        value: value,
        multiple: multiSelectable,
        onFocus: function onFocus() {
          var _a2;
          return (_a2 = store == null ? void 0 : store.getState().selectElement) == null ? void 0 : _a2.focus();
        },
        onChange: function onChange(event) {
          nativeSelectChangedRef.current = true;
          setAutofill(true);
          store == null ? void 0 : store.setValue(multiSelectable ? getSelectedValues(event.target) : event.target.value);
        },
        children: [toArray(value).map(function (value2) {
          if (value2 == null) return null;
          if (values.includes(value2)) return null;
          return /* @__PURE__ */jsx("option", {
            value: value2,
            children: value2
          }, value2);
        }), values.map(function (value2) {
          return /* @__PURE__ */jsx("option", {
            value: value2,
            children: value2
          }, value2);
        })]
      }), element]
    });
  }, [store, label, labelledBy, name, form, required, value, multiSelectable, values]);
  var children = /* @__PURE__ */jsxs(Fragment, {
    children: [value, /* @__PURE__ */jsx(SelectArrow, {})]
  });
  var contentElement = store.useState("contentElement");
  props = __spreadProps(__spreadValues({
    role: "combobox",
    "aria-autocomplete": "none",
    "aria-labelledby": labelId,
    "aria-haspopup": getPopupRole(contentElement, "listbox"),
    "data-autofill": autofill || void 0,
    "data-name": name,
    children: children
  }, props), {
    ref: useMergeRefs(store.setSelectElement, props.ref),
    onKeyDown: onKeyDown
  });
  props = usePopoverDisclosure(__spreadValues({
    store: store,
    toggleOnClick: toggleOnClick
  }, props));
  props = useCompositeTypeahead(__spreadValues({
    store: store
  }, props));
  return props;
});
var Select = forwardRef(function Select2(props) {
  var htmlProps = useSelect(props);
  return createElement(TagName, htmlProps);
});
export { Select, useSelect };